import { render, staticRenderFns } from "./OrderSections.vue?vue&type=template&id=a08ad654&"
import script from "./OrderSections.vue?vue&type=script&lang=ts&"
export * from "./OrderSections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports